import React from "react";
import { Box, Typography } from "@mui/material";
import { useDroppable } from "@dnd-kit/core";

const DropZone = ({ column, color, isEmpty = false }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `dropzone-${column}`,
  });

  return (
    <Box
      ref={setNodeRef}
      sx={{
        minHeight: isEmpty ? "200px" : "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 2,
        border: isOver
          ? `3px dashed ${color}`
          : isEmpty
          ? `2px dashed ${color}40`
          : "2px dashed transparent",
        backgroundColor: isOver
          ? `${color}15`
          : isEmpty
          ? `${color}05`
          : "transparent",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        mt: isEmpty ? 0 : 1,
        opacity: isOver ? 1 : isEmpty ? 0.7 : 0.4,
        position: "relative",
        transform: isOver ? "scale(1.02)" : "scale(1)",
        boxShadow: isOver ? `0 4px 20px ${color}25` : "none",
        "&::before": isOver
          ? {
              content: '""',
              position: "absolute",
              top: "-2px",
              left: "-2px",
              right: "-2px",
              bottom: "-2px",
              background: `linear-gradient(45deg, ${color}20, transparent, ${color}20)`,
              borderRadius: "inherit",
              zIndex: -1,
              animation: "pulse 1.5s ease-in-out infinite",
            }
          : {},
        "@keyframes pulse": {
          "0%, 100%": {
            opacity: 0.5,
          },
          "50%": {
            opacity: 1,
          },
        },
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          opacity: isOver ? 0.8 : 0.5,
          fontStyle: "italic",
          textAlign: "center",
        }}
      >
        {isOver
          ? "Drop task here"
          : isEmpty
          ? "No tasks yet - drag tasks here"
          : "Drop zone"}
      </Typography>
    </Box>
  );
};

export default DropZone;
